module.exports = __webpack_public_path__ + "static/media/mail.48cc9d81.svg";